<template>
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">
      
        <el-col :span="6">
          <el-form-item label="版本类型" prop="versionType">
                <el-select
              v-model="searchForm.versionType"
              style="width: 100%"
              placeholder="版本类型"
              clearable
              
            >
              <el-option
                v-for="item in versionTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
         <el-col :span="6">
          <el-form-item label="固件版本" prop="firmwareVersion">
                <el-input
              clearable
              v-model="searchForm.firmwareVersion"
              placeholder="固件版本"
              maxlength="50"
            ></el-input>
          </el-form-item>
        </el-col>
         <el-col :span="12">
          <el-form-item label="上传日期" prop="account" >
               <el-date-picker
               style="width:100%"
                v-model="searchForm.timeRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00','23:59:59']">
                </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="float:right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="uploadVersion">
          固件上传</el-button
        >
       
      </template>
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :reduceHeight='20'
          :option="option"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>
     
        <template slot-scope="scope" slot="menu">

       <el-button
          type="text"
          size="small"
         
         
          @click="getVersion(scope.row)"
          >下载
        </el-button>
        <el-button
          type="text"
          size="small"
      
         
          @click="deleteVesion(scope.row)"
          >删除
        </el-button>
      
      </template>
    </avue-crud>
    <hr-dialog title="固件上传" :allowFull='false' width="35%" :visible.sync="visible">
      <template slot="body">
         <UploadVersion @cancle='recordCancle' v-if="visible" :model="model" :row="tenantInfoRow" @success='recordSuccess'></UploadVersion>
      </template>
    </hr-dialog>
      
  </basic-container>
</template>
<script>

import { getDictionary } from '@/api/common.js';
import searchFromShow from '@/components/search-form-show/index';
import UploadVersion from './components/uploadVersion.vue';
import {firmwarePage,firmwareRemove} from './api/index'
import {getToken} from '@/util/auth';
export default {
  components: { searchFromShow ,UploadVersion},
  data() {
    return {
        merchantVisible:false,
      merchantVisibleId:'',
      model:'add',
      tenantInfoRow:{},
      configureRow:{},
    
      
      visible:false,
  
      searchForm: {
        firmwareType: '',
       firmwareVersion:'',
       versionType:'',
        startTime:'',
        endTime:'',
        timeRange:''
      },
    
    
      projectList: [],
      
      option: {
        
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '固件版本',
             width:'300px',
            prop: 'firmwareVersion',
          },
          {
            label: '版本类型',
            width:'150px',
            prop: 'versionType',
             dataType:'string',
            dicUrl: "/api/blade-system/dict/dictionary?code=park_version_type",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            
          },
         
          {
            label: '固件URL',
            prop: 'url',
          },
          
            {
            label: '上传时间',
             width:'200px',
            prop: 'uploadTime',
          },
          
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      selectionList:[],
      recordIds:[],
      versionTypeList:[],
      deviceTypeList:[],
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.calcHeight();
  },
  methods: {
    getVersion(row){
        this.tool.downloadFile(`/api/v4ward/park/firmware/download?${
                  this.website.tokenHeader
                }=${getToken()}&name=${row.name}`)
    },
    uploadVersion(){
        this.visible = true
    },
    merchantSetting(row){
        this.merchantVisible = true
         this.tenantInfoRow = row
    },
    modifyPassword(row){
     this.passwordVisible = true
     this.modifyId = row.id
    },
    deleteVesion(row){
      this.$confirm("是否删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          firmwareRemove(row.id).then(()=>{
            this.$message.success('删除成功')
            this.onLoad();
          })
        }
        )
    },
    
    recordCancle(){
      
      this.passwordVisible = false
       this.merchantVisible = false
      this.visible = false
    },
   
    configureCanteen(row){
      this.configureRow= row
      this.passwordVisible = true
    },
    recordSuccess(){
    this.visible = false
      this.passwordVisible = false
      this.merchantVisible = false
      this.passwordVisible = false
      this.onLoad()
    },
    viewRecord(row){
       this.recordTittle = '查看'
       this.tenantInfoRow = row
       console.log('ddd', this.tenantInfoRow )
       this.model = 'view'
      this.visible = true
    },
    addRecord(){
      this.recordTittle = '新增'
      this.model = 'add'
      this.visible = true
    },
    editRecord(row){
      this.recordTittle = '编辑'
      this.model = 'update'
       this.tenantInfoRow = row
      this.visible = true
    },
   
    searchRecord() {
      this.page.currentPage = 1;
   
           if(this.searchForm.timeRange&&this.searchForm.timeRange.length>0){
                this.searchForm.startTime = this.dayjs(this.searchForm.timeRange[0]).format('YYYY-MM-DD 00:00:00')
                this.searchForm.endTime = this.dayjs(this.searchForm.timeRange[1]).format('YYYY-MM-DD 23:59:59')
            }else{
                this.searchForm.timeRange = []
                this.searchForm.startTime = ''
                  this.searchForm.endTime = ''
            }
      this.onLoad();
    },
    searchClear() {
      this.tool.clearObject(this.searchForm, 'projectId');
    },
    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279;
      console.log(' this.option.height', this.option.height)
    },
    async initData() {
       getDictionary('park_device_type').then(res=>{
            this.deviceTypeList = res.data
        })
        getDictionary('park_version_type').then(res=>{
            this.versionTypeList = res.data
        })
    },
    onLoad() {
      this.loading = true;
     
        firmwarePage(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      
    },
   
  },
};
</script>

<style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
</style>
